import { useCallback } from "react";
import { useUpdateDesignProject } from "../api/useUpdateDesignProject";

export function useUpdateWithDeliveryEstimates() {
  const updateProject = useUpdateDesignProject();

  // Delivery estimates are fully handled by useDeliveryDateSync which
  // triggers on optimal DC stock boundary crossings and page load.
  // This hook now only wraps the design project update.
  const handleUpdateWithDeliveryEstimates = useCallback(
    // useUpdateDesignProject already calls notifyError before re-throwing,
    // so no catch block is needed here (MN-4263).
    async (updateParams: Parameters<typeof updateProject.mutate>[0]) =>
      updateProject.mutateAsync(updateParams),
    [updateProject]
  );

  return {
    mutate: handleUpdateWithDeliveryEstimates,
    mutateAsync: handleUpdateWithDeliveryEstimates,
    isPending: updateProject.isPending,
    isSuccess: updateProject.isSuccess,
    isError: updateProject.isError,
    error: updateProject.error,
    data: updateProject.data,
    status: updateProject.status,
    reset: () => {
      updateProject.reset();
    }
  };
}
